<template>
  <!-- 漏斗图报表 -->
  <div class="funnel-report-container" ref="chart">
    <div class="funnel-report-map" ref="funnelReport"></div>
    <div v-if="options.legendData && isDraw" :class="['hint', hintPosition && 'custom-page-hint']">
        <span class="item" v-for="item in getLegend(hintPosition ? 1 : 3)" :key="item.color" :title="item.name">
          <span class="item-color" :style="{background: item.color}"></span>
          <span class="name" :style="getFontStyle(chartFont, true)">{{ item.name }}</span>
        </span>
      <span v-if="options.legendData.length > (hintPosition ? 1 : 3)"
            :class="!isOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click.stop="isOpen = !isOpen"
            :style="getFontStyle(chartFont, true)"></span>
      <transition name="el-zoom-in-top">
        <div v-show="isOpen" :class="['list-color', hintPosition && 'custom-list-color']" :style="{'background-color': getBgc(bgc)}">
          <span class="item" v-for="item in getLegend(options.legendData.length, hintPosition ? 1 : 3)"
                  :key="item.color" :title="item.name">
            <span class="item-color" :style="{background: item.color}"></span>
            <span class="name" :style="getFontStyle(chartFont, true)">{{ item.name }}</span>
          </span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { publicMethods } from './mixin'
import Vue from 'vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/funnel')
Vue.use(echarts)
export default {
  name: 'funnel-report',
  props: ['graphData', 'norm', 'dimensionality', 'hintPosition'],
  data () {
    return {
      options: {},
      isOpen: false,
      isDraw: false,
      myChart: null,
      count: 0,
      end: 50,
      num: null,
      timer: null
    }
  },
  mixins: [ publicMethods ],
  methods: {
    drawLine () {
      if (this.myChart) {
        this.myChart.dispose()
      }
      this.isOpen = false
      let newData = this.$_.cloneDeep(this.graphData)
      newData.forEach(m => {
        m.dataDimension.forEach(o => {
          o.value = this.handleData(o.value, this)
        })
      })
      this.$set(this, 'options', this.$_.cloneDeep(this.disposeData(newData)))
      this.setEndValue()
      this.$nextTick(() => {
        let _self = this
        _self.isDraw = true
        // 基于准备好的dom，初始化echarts实例
        this.myChart = echarts.init(this.$refs.funnelReport)
        let options = {
          title: {},
          tooltip: {},
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: this.options.series,
          color: this.options.color,
          textStyle: this.getTextStyle,
          label: {
            show: true,
            position: 'top',
            textStyle: this.getTextStyle,
            formatter: valueObj => {
              let value = valueObj.value
              let showName = false
              let name = valueObj.name
              if (isNaN(parseFloat(valueObj.name))) {
                showName = true
              }
              if (parseFloat(value) !== 0 && !isNaN(parseFloat(value))) {
                return _self.formatValue(value, _self, showName, name)
              } else {
                return ''
              }
            },
            emphasis: {
              fontSize: 20
            },
            normal: {
              fontSize: 10
            }
          }
        }
        if (!this.isCustomPage) {
          options.grid = {
            left: '150',
            right: '40'
          }
        }
        // 绘制图表
        this.myChart.setOption(options)
        this.extension(this.myChart)
      })
    },
    disposeData (list) {
      list = this.$_.cloneDeep(list)
      let color = []
      let xAxisData = []
      let legendData = []
      let series = []
      // 一维度 和 两维度 数据不一样。
      if (list && list.length) {
        if (this.dimensionality && this.dimensionality.length === 1) {
          xAxisData = list[0].dataDimension.map(li => li.name)
          legendData = list[0].dataDimension.map(li => li.name)
          let min = 0
          let max = 0
          let minSize = '0%'
          let maxSize = '100%'
          let data = []
          let sort = ''
          let sum = eval(list[0].dataDimension.map(item => item.value).join('+'))
          list[0].dataDimension.forEach(item => {
            let itemValue = 0
            minSize = '100%'
            if (item.value > max) {
              max = item.value
            }
            if (item.value < min) {
              min = item.value
            }
            minSize = (min / max) * 100 + '%'
            itemValue = (item.value / sum * 100)
            data.push({name: item.name, value: item.value, itemStyle: {height: `${itemValue}%`}})
          })
          // 定制 "17B99F74-BFA0-0065-3F1E-B11F45B1BC91"
          if (this.dimensionality.length > 0 && this.dimensionality[0].tableId === '17B99F74-BFA0-0065-3F1E-B11F45B1BC91') {
            let arr = ['初步接触', '挖掘需求', '方案和报价', '商务谈判', '赢单', '输单', '取消']
            let finalData = []
            arr.forEach(item1 => {
              finalData[finalData.length] = data.find(item => {
                return item.name === item1
              })
            })
            let finalData1 = []
            finalData.forEach(item => {
              if (item !== undefined && !['输单', '取消'].includes(item.name)) {
                finalData1.push(item)
              }
            })
            finalData1.forEach((item, index) => {
              item.value = this.getFallValue(index, finalData1)
            })
            data = finalData1
            sort = 'none'
            min = 1
            minSize = '20%'
            maxSize = '100%'
          }
          if (!sort) {
            this.sortByKey(data, 'value')
          }
          data.forEach((item, index) => {
            item.itemStyle.height = 100 / data.length + '%'
            item.data = item.value
            item.value = data.length - index
          })
          data.forEach((item, index) => {
            if (index === (data.length - 1)) {
              item.rate = ''
            } else {
              item.rate = (data[index + 1].data / data[index].data * 100).toFixed(2)
            }
            if (item.value > max) {
              max = item.value
            }
            if (item.value < min) {
              min = item.value
            }
          })
          series.push({
            name: '',
            type: 'funnel',
            data: data, // list[0].dataDimension.map(li => li.value),
            left: '10%',
            top: 60,
            bottom: 60,
            width: '80%',
            min: min,
            max: max,
            minSize: minSize,
            maxSize: maxSize,
            sort: sort || 'descending',
            gap: 2,
            label: {
              show: true,
              position: 'rightBottom',
              formatter: (params) => {
                if (params.data.rate) {
                  return '转化率' + params.data.rate + '%'
                } else {
                  return ''
                }
              }
            }
          })
          series.push({
            name: '',
            type: 'funnel',
            data: data, // list[0].dataDimension.map(li => li.value),
            left: '10%',
            top: 60,
            bottom: 60,
            width: '80%',
            min: min,
            max: max,
            minSize: minSize,
            maxSize: maxSize,
            sort: sort || 'descending',
            gap: 2,
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                return params.data.name + ':' + params.data.data
              }
            },
            label: {
              show: true,
              position: 'inside',
              formatter: (params) => {
                return params.data.name + ':' + params.data.data
              }
            }
          })
          color = this.getDefaultColors(list[0].dataDimension.length)
        } else if (this.dimensionality && this.dimensionality.length === 2) {
          xAxisData = list.map(li => li.dateDimension)
          color = this.getDefaultColors(list[0].dataDimension.length)
          list.forEach((li, i) => {
            if (i === 0) {
              legendData = li.dataDimension.map(d => d.name)
            }
            li.dataDimension.forEach((d, x) => {
              if (series[x] === undefined) {
                series.push({
                  name: d.name,
                  type: 'funnel',
                  data: [d.value]
                })
              } else {
                series[x].data.push(d.value)
              }
            })
          })
        }
      }
      return {xAxisData, legendData, series, color}
    },
    // 先把数据处理 formatValue然后展示的时候再加单位
    handleData (value, _self) {
      let oldValue = value
      let norm = _self.norm
      let decimalDigits = _self.norm ? _self.norm.decimalDigits : ''
      let percent = (value / _self.count) * 100
      if (norm.showUnit !== '%' && decimalDigits !== '' && decimalDigits !== '请选择') {
        value = value.toFixed(parseFloat(norm.decimalDigits))
      }
      if (norm && norm.showType === '显示千分位分隔符') {
        value = _self.formatMoney(value)
      } else if (norm && norm.showType === '显示百分比') {
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = percent.toFixed(decimalDigits)
        }
      }
      if (norm && norm.showUnit === '万元') {
        value = oldValue / 10000
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = value.toFixed(parseFloat(norm.decimalDigits))
        }
        if (norm.showType === '显示千分位分隔符') {
          value = _self.formatMoney(value)
        } else if (norm.showType === '显示百分比') {
          if (decimalDigits !== '' && decimalDigits !== '请选择') {
            value = percent.toFixed(decimalDigits)
          } else {
            value = percent
          }
        }
      } else if (norm && norm.showUnit === '%' && norm && norm.showType !== '显示百分比') {
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = parseFloat(value * 100).toFixed(parseFloat(norm.decimalDigits))
        } else {
          value = parseFloat((value * 100).toFixed(10))
        }
      }
      return value
    },
    formatValue (value, _self, showNamem, name) {
      let oldValue = value
      let norm = _self.norm
      if (norm && norm.showType === '显示千分位分隔符') {
        value = _self.formatMoney(value)
      } else if (norm && norm.showType === '显示百分比') {
        value = value + '%'
      }
      if (norm && (norm.showUnit === '元' || norm.showUnit === '件')) {
        value += norm.showUnit
      } else if (norm && norm.showUnit === '万元') {
        value = oldValue
        if (norm.showType === '显示千分位分隔符') {
          value = _self.formatMoney(value)
        } else if (norm.showType === '显示百分比') {
          value = value + '%'
        }
        value = value + '万元'
      } else if (norm && norm.showUnit === '%' && norm && norm.showType !== '显示百分比') {
        value = value + '%'
      }
      return showNamem ? (name + '：' + value) : value
    },
    resize () {
      this.setEchartsVisual('funnelReport')
      this.myChart && this.myChart.resize()
    },
    sortByKey (array, key) {
      return array.sort(function (a, b) {
        let y = a[key]
        let x = b[key]
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
    },
    getFallValue (index, arr) {
      let result = 0
      for (let i = index; i <= arr.length - 1; i++) {
        result += arr[i].value
      }
      return result
    }
  },
  mounted () {
    let that = this
    this.timer = setInterval(() => {
      if (this.num === 3) {
        let myIdElement = this.$refs.chart
        myIdElement && myIdElement.classList.remove('has-background')
      }
      this.num++
    }, 1000)
    this.$nextTick(() => {
      let myIdElement = this.$refs.chart
      if (myIdElement) {
        // 滚动
        myIdElement.onscroll = function (e) {
          myIdElement.classList.add('has-background')
          that.num = 0
        }
        // 移入
        myIdElement.onmouseover = function (e) {
          myIdElement.classList.add('has-background')
          that.num = 0
        }
      }
      // 设置初始echarts绘画容器大小,防止隐藏时拿不到高度
      this.setEchartsVisual('funnelReport')
    })
  },
  created () {
    this.count = this.getCount()
  },
  beforeDestroy () {
    let extension = document.getElementById('extension-graph')
    extension && document.body.removeChild(extension)
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss">
  .funnel-report-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: relative;
    .funnel-report-map {
      width: 100%;
      height: 100%;
    }
    .hint {
      position: absolute;
      right: 15px;
      width: 280px;
      z-index: 999;
      height: 20px;
      top: 0;
      font-size: 14px;
      .item {
        margin-left: 38px;
        width: 50px;
        display: inline-block;
        position: relative;
        cursor: pointer;
        font-size: inherit;
        .item-color {
          position: absolute;
          left: -20px;
          top: 4px;
          width: 12px;
          height: 12px;
          font-size: inherit;
        }
        .name {
          width: 50px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: inherit;
        }
      }
      .el-icon-arrow-down, .el-icon-arrow-up {
        position: absolute;
        right: -9px;
        top: 2px;
        cursor: pointer;
        font-size: inherit;
      }
      .list-color {
        position: absolute;
        right: 0px;
        top: 24px;
        height: 150px;
        width: 280px;
        overflow: auto;
        background-color: #fff;
        z-index: 999;
        box-shadow: 0 0 4px 3px #EBEBEB;;
        border-radius: 4px;
        padding: 5px 0;
      }
      .custom-list-color {
        top: -130px;
        width: 195px;
        padding-left: 4px;
        height: 125px;
      }
    }
    .custom-page-hint {
      bottom: 50px;
      top: inherit;
      width: 90px;
      text-align: left;
    }
    .set-bottom {
      bottom: 15px;
      top: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/graphReport/funnel-report.vue